// @flow
import * as React from 'react';
import { type ThemeType } from 'react-css-themr';
import classnames from 'classnames';
import { Icon } from 'common/components/core/icon';

type Props = {
    theme: ThemeType,
    isSelected: boolean,
    selectable: boolean,
    onSectionClick: () => void,
    className?: ?string,
    source: { title: React.Node, icon?: string },
    testId?: string
};

export default class DefaultNavGroupTitle extends React.PureComponent<Props> {
    render() {
        const {
            theme,
            isSelected,
            selectable,
            onSectionClick,
            className,
            source,
            testId
        } = this.props;
        const { title, icon } = source;
        return (
            <div
                className={classnames(theme.navGroupTitle, {
                    [theme.selectedItem]: isSelected,
                    [theme.selectable]: selectable,
                    [className]: !!className
                })}
                onClick={onSectionClick}
                data-test-id={testId}
            >
                {icon ? (
                    <Icon
                        icon={icon}
                        theme={theme}
                        className={theme.navGroupIcon}
                    />
                ) : null}
                <span className={theme.text}>{title}</span>
            </div>
        );
    }
}
